import { systemText } from '../../helpers/string';
import React from 'react';

const SlideDown = props => {
	const [hovering, setHovering] = React.useState(false);
	const [moveEvent, setMoveEvent] = React.useState({});

	const sliderPanel = React.useRef(null);

	React.useEffect(() => {
		if (props.sliderLogo.current && sliderPanel.current) {
			const overPanel = sliderPanel.current.contains(moveEvent.target);
			const overLogo = props.sliderLogo.current.contains(moveEvent.target);
			setHovering(overLogo || overPanel);
		}
	}, [props.sliderLogo.current, sliderPanel.current, moveEvent]);

	React.useEffect(() => {
		document.addEventListener('mousemove', setMoveEvent, false);

		return () => {
			document.removeEventListener('mousemove', setMoveEvent, false);
		};
	}, []);

	return (
		<div
			ref={sliderPanel}
			className={hovering ? 'slidedown' : 'slideup'}
			style={{ zIndex: '999', position: 'absolute', width: '100%' }}
		>
			<div
				className="p10 widget-recommendation"
				style={{
					...props.extraStyles,
					borderBottomLefttRadius: '2px',
					borderBottomRightRadius: '2px',
					backgroundColor: 'rgba(255, 224, 223, 1)',
					boxShadow: '2px 2px 2px rgba(0, 0, 0, 0.2)',
				}}
			>
				<div className="flex flex-center" style={{ paddingTop: '4px', paddingBottom: '10px' }}>
					<div className="pointer e4-logo mr10 highlight" />
					{props.header}
				</div>
				{props.content}
			</div>
			<div
				style={{
					float: 'right',
					padding: '0px 10px 5px',
					marginRight: '5px',
					marginBottom: '5px',
					borderBottomLeftRadius: '5px',
					borderBottomRightRadius: '5px',
					display: 'inline-block',
					backgroundColor: 'rgba(255, 224, 223, 1)',
					boxShadow: '2px 2px 2px rgba(0, 0, 0, .2)',
					fontSize: '12px',
				}}
			>
				{systemText('Dashboard/Widgets/General/Recommends/E4')}
			</div>
		</div>
	);
};

export default SlideDown;
